import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { ButtonController, IButtonControllerOptions } from "../../../Common/ButtonController";
import { GameModel } from "../../../Models/GameModel";
import { UIDailyRewardControllerOptions, UIDailyRewardController } from "./UIDailyRewardController";
import {AnimationContents} from "../../../../AnimationContents";

export interface IUIActionControllerOptions {
    showBox?: boolean;
}

export class UIActionController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IUIActionControllerOptions,) {
        super('UIActionController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.MAIN_SCREEN_JSON,
            libraryName: 'action_container',
            childControllers: {
                add_box: {
                    instanceName: 'add_box',
                    controller: UIDailyRewardController,
                    model: this.$model,
                },
                btn_action: {
                    instanceName: 'btn_action',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {}
                    }
                },
            }
        }
    }

    protected onInitialize() {
        this.$childControllers.get('add_box').visible = 'showBox' in this._options ? this._options.showBox : true;
        this.$childControllers.get('btn_action').visible = false;
    }

}
